import { render, staticRenderFns } from "./newPhoneOrEmailCodeInput.vue?vue&type=template&id=58843753&scoped=true&"
import script from "./newPhoneOrEmailCodeInput.vue?vue&type=script&lang=js&"
export * from "./newPhoneOrEmailCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./newPhoneOrEmailCodeInput.vue?vue&type=style&index=0&id=58843753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58843753",
  null
  
)

export default component.exports